<template>
  <div>
    <!-- 面包屑导航 -->

    <el-card style="min-height: 600px;width: 98%;">
      <el-form :model="companyFiling" :inline="true" label-width="100px" style="margin-top: 10px;">
        <el-col :span="12">
          <el-form-item label="公司名称" label-width="150px">
            <el-input  :disabled="state"  v-model="companyFiling.companyName" placeholder="请输入公司名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="注册地址" label-width="150px">
            <el-input   :disabled="state"  v-model="companyFiling.registeredAddress" placeholder="请输入注册地址"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="营业执照" label-width="150px">
            <el-input  :disabled="state"    v-model="companyFiling.businessLicense" placeholder="请输入营业执照"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="组织机构代码证" label-width="150px">
            <el-input   :disabled="state"  v-model="companyFiling.organizationCodeCertificate" placeholder="请输入组织机构代码证"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="法人姓名" label-width="150px">
            <el-input  :disabled="state"    v-model="companyFiling.legalPerson" placeholder="请输入法人姓名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="法人身份证号" label-width="150px">
            <el-input   :disabled="state"  v-model="companyFiling.legalPersonNumber" placeholder="请输入法人身份证号"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="商标注册证" label-width="150px">
            <el-input   :disabled="state"  v-model="companyFiling.trademark" placeholder="请输入商标注册证"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="税务登记证" label-width="150px">
            <el-input   :disabled="state"  v-model="companyFiling.taxRegistration" placeholder="请输入税务登记证"></el-input>
          </el-form-item>
        </el-col>
      <el-button type="primary" @click="save()" v-if="!state"  icon="el-icon-check"
					style="margin-left: 31%;width:300px">提交
				</el-button>
      </el-form>

    </el-card>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        companyFiling: {
          id: sessionStorage.getItem('companyId'),
          companyName: "",
          businessLicense: "",
          organizationCodeCertificate: "",
          legalPerson: "",
          legalPersonNumber: "",
          taxRegistration: "",
          registeredAddress: "",
          state: 1,
          registeredAddress:"",
          phone:"",
        },
        state:false,

      };
    },
    created() {
      this.getCompanyFiling();
    },
    methods: {
    async getCompanyFiling() {
          const {
            data: res
          } = await this.$http.get("/companyFiling/getById/" + this.companyFiling.id);
        this.companyFiling=res;
        if(this.companyFiling.state!=1){this.state=true;}
      },
      save() {
        this.$http.post('/companyFiling/save', this.companyFiling).then((res) => {
          this.$message({
            showClose: true,
            message: '添加企业备案信息成功，请等待审核',
            type: 'success'
          });
        })

      },


    }

  };
</script>

<style lang="scss" scoped>
  .select {
    width: 210px;
    height: 40px;
    border-color: #dcdfe6;
  }

  .selectAdd {
    width: 194px;
    height: 40px;
    border-color: #dcdfe6;
  }
</style>
